<template>
	<el-row>
		<el-button @click="add()">添加节日+</el-button>
		<el-row>
			<el-col>
				<span>节日搜索</span>
				<el-col :span="6" style="margin: 0 10px;">
					<el-input v-model="festivalName"></el-input>
				</el-col>
				<el-button @click="query()" type="primary">筛选</el-button>
				<!-- <el-button @click="Export()" type="warning">导出Excel</el-button> -->
				<el-button @click="reset()" type="success">重置</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<el-table :data="tableData" height="600px">
					<el-table-column label="序号" prop="id" width="50px"></el-table-column>
					<el-table-column label="年份" prop="year"></el-table-column>
					<el-table-column label="节日名称" prop="festivalName"></el-table-column>
					<el-table-column label="圈文素材">
						<template slot-scope="scope">
							{{scope.row.qw.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="视频">
						<template slot-scope="scope">
							{{scope.row.sp.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="海报">
						<template slot-scope="scope">
							{{scope.row.hb.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="课程" prop="">
						<template slot-scope="scope">
							{{scope.row.curriculumDTOList.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<!-- 	<el-table-column label="节日款商品">
						<template slot-scope="scope">
							{{scope.row.jrksp.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="节日活动" prop="">
						<template slot-scope="scope">
							{{scope.row.jrhd.length>0 ?"有" :"无"}}
						</template>
					</el-table-column>
					<el-table-column label="商品主图">
						<template slot-scope="scope">
							{{scope.row.spzt.length>0 ?"有" :"无"}}
						</template>
					</el-table-column> -->
					<el-table-column label="创建时间" prop="createTime"></el-table-column>
					<el-table-column label="更新时间" prop="updateTime"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="editor(scope.row)" type="text" size="mini" style="color: #a6e22e;">编辑
							</el-button>
							<el-button @click="toView(scope.row)" type="text" size="mini">查看</el-button>
							<el-button @click="del(scope.row)" type="text" size="mini" style="color: red;">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="dialogVisible" center width="30%">
			<el-form ref="info" :model="info" label-position="right" label-width="100px">
				<el-form-item label="年份" prop="year" :rules="[{
					 required: true, message: '请输入节日年份', trigger: 'blur'
				}]">
					<el-input v-model="info.year" placeholder="例如:2022年"></el-input>
				</el-form-item>
				<el-form-item label="节日名称" prop="festivalName" :rules="[{
					 required: true, message: '请输入节日名称', trigger: 'blur'
				}]">
					<el-input v-model="info.festivalName" placeholder="例如:六一儿童节"></el-input>
				</el-form-item>
				<el-form-item label-width="200px">
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				festivalName: '',
				total: 0,
				pageNum: 1,
				pageSize: 30,
				dialogVisible: false,
				title: '',
				info: {
					id: '',
					year: '',
					festivalName: ''
				}
			}
		},
		methods: {
			//添加
			add() {
				this.dialogVisible = true
				this.info.year = ''
				this.info.festivalName = ''
				this.title = '添加节日'
			},
			//查询
			query() {
				this.getList()
			},
			//导出
			Export() {
				this.$http.post(`/api/statistics/knowledgeBase/exportFestival`, {
					festivalName: this.festivalName,
					dataType: 0
				}, {
					responseType: 'blob'
				}).then(res => {
					console.log(res);
					this.$message({
						type: 'info',
						message: '正在导出节日表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '节日列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			reset() {
				this.festivalName = ''
				this.getList()
			},
			//确认
			submit() {
				this.$refs.info.validate((valid) => {
					if (valid) {
						switch (this.title) {
							case '添加节日': {
								this.$http.post('/api/plant/knowledgeBase/insertFestival', {
									"year": this.info.year, //年份
									"festivalName": this.info.festivalName, //节日名称
									"dataType": 0
								}).then(res => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.dialogVisible = false
										this.getList()
									}
								})
								break
							}
							case '编辑节日': {
								this.$http.post('/api/plant/knowledgeBase/updateFestival', {
									"id": this.info.id,
									"year": this.info.year, //年份
									"festivalName": this.info.festivalName //节日名称
								}).then(res => {
									console.log(res.data);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.dialogVisible = false
										this.getList()
									}
								})
								break
							}
						}
					} else {
						return false
					}
				})
			},
			//编辑
			editor(row) {
				console.log(row);
				this.title = '编辑节日'
				this.dialogVisible = true
				this.info = {
					id: row.id,
					year: row.year,
					festivalName: row.festivalName
				}
			},
			//删除
			del(row) {
				this.$confirm('此操作将永久删除该节日, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/knowledgeBase/updateFestival', {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.success('删除成功')
							this.getList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查看
			toView(row) {
				this.$router.push({
					path: './details',
					query: {
						id: row.id,
						year: row.year,
						festivalName: row.festivalName
					}
				})
			},
			//获取列表
			getList() {
				this.$http.post('/api/plant/knowledgeBase/selectFestival', {
					"festivalName": this.festivalName,
					"pageNum": this.pageNum,
					"pageSize": this.pageSize,
					"dataType": 0
				}).then(res => {
					let newData = res.data.data.list
					if (newData.length > 0) {
						console.log(newData[0]);
						newData.forEach(item => {
							item.qw = []
							item.sp = []
							item.hb = []
							item.jrksp = []
							item.jrhd = []
							item.spzt = []
							if (item.festivalCommodityVos.length > 0) {
								item.festivalCommodityVos.forEach(i => {
									item.jrksp.push(i)
								})
							}
							if (item.paragraphVos.length > 0) {
								item.paragraphVos.forEach(i => {
									if (i.paragraphType == "03") {
										item.qw.push(i)
									}
								})
							}
							if (item.materialPicVos.length > 0) {
								item.materialPicVos.forEach(i => {
									if (i.materialType == "04") {
										item.sp.push(i)
									}
									if (i.materialType == "03") {
										item.hb.push(i)
									}
									if (i.materialType == "02") {
										item.spzt.push(i)
									}
								})
							}
						})
					}
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getList()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList()
			},
		},
		created() {
			this.getList()
		}
	}
</script>

<style scoped>
</style>
